import {
  MaintenanceContainer,
  Title,
  Content,
  Team,
  MaintenanceWrapper,
  MaintenanceSvg,
} from './Maintenance.styles'

const Maintenance = () => {
  return (
    <MaintenanceContainer>
      <MaintenanceWrapper>
        <MaintenanceSvg />
        <Title>We&rsquo;ll be back soon!</Title>
        <div>
          <Content>
            Sorry for the inconvenience. We&rsquo;re performing some maintenance at the moment. We
            will be back up shortly!
          </Content>
          <Team>Minebase Team</Team>
        </div>
      </MaintenanceWrapper>
    </MaintenanceContainer>
  )
}

export default Maintenance
